import { Flex, FlexProps } from '@chakra-ui/react'

import { BrandColor } from 'src/types'

import BrandedVoiceTipIcon from '../BrandedVoiceTipIcon/BrandedVoiceTipIcon'
import ItListImage from '../ItListImage/ItListImage'

const VoiceTipIcon = ({
  brandColor,
  profileImage,
  imageSize = 24,
  voiceTipSize = 19,
  voiceTipPosition = -2,
  ...props
}: {
  brandColor: BrandColor
  profileImage: string
  imageSize?: number
  voiceTipSize?: number
  voiceTipPosition?: number
} & FlexProps) => (
  <Flex alignItems="center" {...props}>
    <ItListImage
      htmlWidth={imageSize}
      htmlHeight={imageSize}
      alt="profile image"
      src={profileImage}
      boxSize={`${imageSize}px`}
      borderRadius="full"
      objectFit="cover"
    />
    <BrandedVoiceTipIcon
      brandColor={brandColor}
      iconOutlineColor="white"
      w={`${voiceTipSize}px`}
      h={`${voiceTipSize}px`}
      ml={voiceTipPosition}
    />
  </Flex>
)

export default VoiceTipIcon
